// extracted by mini-css-extract-plugin
export var bottom = "styles-module--bottom--cdada";
export var container = "styles-module--container--2967d";
export var expand = "styles-module--expand--0f50a";
export var shrink = "styles-module--shrink--526b1";
export var top = "styles-module--top--9a13e";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--6242d";